import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';

export function StatusPill({ isConnected }: { isConnected: boolean }) {
  return (
    <div
      className={clsx(
        'flex h-6 w-fit items-center justify-center gap-1 rounded-full px-2 whitespace-nowrap',
        isConnected ? 'bg-fx-green-50' : 'bg-fx-rose-50',
      )}
    >
      <span
        className={clsx(
          'h-1 w-1 rounded-full',
          isConnected ? 'bg-fx-green' : 'bg-fx-rose',
        )}
      />
      <Typography
        variant="small1"
        className={clsx(
          'px-1',
          isConnected ? '!text-fx-green-800' : '!text-fx-rose-800',
        )}
      >
        {isConnected ? (
          <FormattedMessage
            defaultMessage="Activated"
            description="Status for the activate channel"
          />
        ) : (
          <FormattedMessage
            defaultMessage="Not activated"
            description="Status for the not activated channel"
          />
        )}
      </Typography>
    </div>
  );
}
